var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      key: _vm.item.model.id,
      staticClass: "d-flex",
      class: { current: _vm.isCurrent },
      style: _vm.styles,
      on: { click: _vm.selectItem },
    },
    [
      _c("div", { staticClass: "flex-grow-1" }, [
        _c("div", { staticClass: "item-title" }, [
          _c(
            "span",
            {
              staticClass: "list-name",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [_vm._v(_vm._s(_vm._f("uppercase")(_vm.name)))]
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "item-info" }, [
          _c("span", [
            _vm._v(
              _vm._s(_vm.contactCount) +
                " contacts, created " +
                _vm._s(_vm.createdDiff)
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-tooltip",
            { attrs: { content: "Edit", placement: "top-start" } },
            [
              _c(
                "span",
                {
                  staticClass: "btn btn-link btn-link-purple btn-sm",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.edit.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "fas fa-edit" })]
              ),
            ]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }